import axios from 'axios';
import Cookies from 'js-cookie';
import { decryptData } from './utils';

const baseUrl = process.env.REACT_APP_API_URL;

const axiosInstance = axios.create({
  baseURL: `${baseUrl}/api`,
  headers: { 'Content-Type': 'application/json' },
});

axiosInstance.interceptors.request.use(
  (config) => {
    const token = Cookies.get('token'); // Replace 'your_cookie_name' with the actual name of your cookie
    if (token) {
      config.headers.Authorization = `Bearer ${decryptData(token)}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

export default axiosInstance;
